import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {ConfigRouteEnum} from "../../shared/enums/config-route.enum";
import {ConfigWriteUserService} from "../../shared/services/config-write-user.service";

export const configWriteGuard: CanActivateFn = () => {
    const router = inject(Router);
    const configWriteUser = inject(ConfigWriteUserService)

    if (configWriteUser.isAuthorized) {
        return true;
    }

    return router.createUrlTree([ConfigRouteEnum.HOME]);
};